import { Provider, type SourceAccount } from '@repo/api-gw-sdk';
import { useMemo } from 'react';

import { useSourceAccounts } from './useSourceAccounts';

// SaaS providers (e.g. Google Workspace) live in the same source-account list
// as cloud-platform providers; this predicate is how callers separate them
// client-side instead of asking the server to filter by providerCategory.
export const isSaasProvider = (provider: Provider) =>
  provider === Provider.GoogleWorkspace || provider === Provider.Microsoft365;

const toSortedProviders = (accounts: SourceAccount[] | undefined) =>
  Array.from(
    (accounts || []).reduce((acc, account) => {
      const provider = account.sourceAccountAttributes.cloudProvider;
      if (provider !== Provider.ProviderUnspecified) {
        acc.add(provider);
      }
      return acc;
    }, new Set<Provider>())
  ).sort();

export const useCloudProviders = () => {
  const { sourceAccounts } = useSourceAccounts();

  return useMemo(() => toSortedProviders(sourceAccounts), [sourceAccounts]);
};

export const getAllCloudProviders = (isDemoOrDev: boolean) =>
  Object.values(Provider).filter(
    (x) =>
      x !== Provider.ProviderUnspecified &&
      x !== Provider.GoogleWorkspace &&
      x !== Provider.Microsoft365 &&
      x !== Provider.AzureEntraId &&
      (isDemoOrDev || x !== Provider.MongoAtlas)
  );
